export default {
    clients: '取引先：{{count}}社',
    createdDocuments: '作成済み書類：{{count}}通',
    message: '次のデータが削除されると、復元することはできません。',
    noLongerAbleToUseMakeLeaps: 'MakeLeapsをご利用いただけなくなります。',
    receivedDocuments: '受信済み書類：{{count}}通',
    submitButton: '削除を確定',
    teamMemberAccounts: '同時に削除されるメンバーのアカウント',
    teamMembers: 'メンバー数：{{count}}名',
    title: '削除',
    yourCompany: '会社アカウント： {{company}}',
    yourUserAccount: 'ユーザーアカウント',
};
